import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_project_agent_RowClass} from "../../../../dbschema/bl_alg_cc_project_agent_link.model";

export class ProjectAgentContainerModel extends BaseContainerModel {
  bl_alg_cc_project_agent_link: bl_alg_cc_project_agent_RowClass = new bl_alg_cc_project_agent_RowClass();
}
